module.exports = __webpack_public_path__ + "media/images/eco_label-17eb967abc8e2c6beee0ef4409e50cd5.png";